<template>
  <div class="organ-diseases-page">
    <van-nav-bar
      title="脏腑易患病症"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
      safe-area-inset-top
    />

    <div class="teal-bg">
      
      <!-- 解析说明卡片 -->
      <div class="card-container">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/解析说明.png" alt="解析说明" class="header-icon" />
          <span class="header-title">解析说明</span>
        </div>
        <div class="introduce-text">
          {{ introduce }}
        </div>
      </div>

      <!-- 脏腑易患病症列表卡片 -->
      <div class="card-container list-card">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/肺腑易患病症.png" alt="肺腑易患病症" class="header-icon" />
          <span class="header-title">肺腑易患病症</span>
        </div>

        <div class="list-wrapper">
          <div class="disease-item" v-for="(item, index) in list" :key="`${item.name || 'item'}-${index}-${item.img || ''}`">
            <!-- 第一行：图标与名称 -->
            <div class="item-title-row">
              <img :src="item.img" :alt="item.name" class="item-icon" />
              <span class="item-name">{{ item.name }}</span>
            </div>
            
            <!-- 第二行：具体表现/结果 -->
            <div class="item-result">
              {{ item.result }}
            </div>
            
            <!-- 第三行：提示 -->
            <div class="item-tips">
              提示：{{ item.tips }}
            </div>
          </div>
        </div>
      </div>

      <!-- 底部声明与时间 (无白色背景) -->
      <div class="bottom-statement">
        <div class="statement-text">
          重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论，如已有身体不适，请及时咨询医生。
        </div>
        <div class="time-text" v-if="createAt">
          生成时间：{{ formatTime(createAt) }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { NavBar, Icon } from 'vant';

export default {
  name: 'MyAiOrganDiseases',
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
  },
  data() {
    return {
      introduce: '',
      list: [],
      createAt: ''
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    loadData() {
      const dataStr = sessionStorage.getItem("MY_AI_ORGAN_DISEASES");
      if (dataStr) {
        try {
          const data = JSON.parse(dataStr);
          this.introduce = data.introduce || '';
          this.list = this.normalizeList(data.list || []);
          this.createAt = data.createAt || '';
        } catch (e) {
          console.error("解析脏腑易患病症数据失败", e);
        }
      }
    },
    normalizeList(list) {
      return list.map((item) => ({
        ...item,
        img: this.correctOrganImage(item?.name, item?.img),
      }));
    },
    correctOrganImage(name, url) {
      const formattedUrl = this.formatImageUrl(url);
      const organImageMap = {
        '心脏': 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/心脏.png',
        '肝脏': 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/肝脏.png',
        '脾脏': 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/脾脏.png',
        '肺脏': 'https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/肺脏.png',
      };
      const expectedUrl = organImageMap[name];
      if (!expectedUrl) return formattedUrl;

      const encodedExpectedUrl = encodeURI(expectedUrl);
      if (!formattedUrl) return encodedExpectedUrl;

      return formattedUrl.includes(`${name}.png`) ? formattedUrl : encodedExpectedUrl;
    },
    formatImageUrl(url) {
      if (!url) return '';
      if (/^https?:\/\//.test(url)) {
        return encodeURI(url);
      }
      return url;
    },
    formatTime(timeStr) {
      if (!timeStr) return '';
      try {
        const parts = timeStr.split(' ');
        const dateParts = parts[0].split('-');
        return `${dateParts[0]}年${parseInt(dateParts[1], 10)}月${parseInt(dateParts[2], 10)}日 ${parts[1] || ''}`;
      } catch (e) {
        return timeStr;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.organ-diseases-page {
  background: #44C2C4;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.teal-bg {
  flex: 1;
  background: #44C2C4;
  padding: 16px 12px;
}

.card-container {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-bottom: 16px;
}

.card-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.header-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
  object-fit: contain;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

/* 解析说明 */
.introduce-text {
  background: #f7f8fa;
  padding: 16px;
  border-radius: 8px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}

/* 列表卡片 */
.list-card {
  padding: 20px 8px;
}

.list-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.disease-item {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
}

/* 第一行：图标和标题 */
.item-title-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.item-icon {
  width: 40px;
  height: 40px;
  margin-right: 8px;
  object-fit: contain;
  flex-shrink: 0;
}

.item-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

/* 第二行：具体表现 */
.item-result {
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 12px;
  font-weight: 500;
}

/* 第三行：提示 */
.item-tips {
  font-size: 13px;
  color: #999;
  line-height: 1.5;
}

/* 底部声明与时间 (无白色背景版) */
.bottom-statement {
  padding: 16px 12px;
  margin-top: 8px;
}

.statement-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8); /* 半透明白色，适应深青色背景 */
  line-height: 1.6;
  text-align: justify;
}

.time-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 8px;
  text-align: center;
}
</style>
